import React, {Suspense} from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
// import ProductPage from './refresh/pages/ProductPage';
// import ProductPageFleek from './fleek/pages/ProductPage';
import { getCurrentStore } from './refresh/selectors/metaData';
import { getMasterFlagFleek } from './refresh/selectors/featureFlagsSelector';
import { FLEEK_STORE_NAME } from './fleek/utils/constants';
import Loader from './components/common/Loader';
import './static/scss/mobile/new-product-page.scss';

const ProductPageFleek = React.lazy(() =>
  import(
    './fleek/pages/ProductPage'
  )
);

const ProductPage = React.lazy(() =>
  import(
    './refresh/pages/ProductPage'
  )
);

const routes = ({ currentStore, isFleekEnabled = false }) => (
  <Router>
    <Suspense fallback={<Loader name="pdp-fleek-pdp"/>}>
      <Switch>
        <Route
          exact
          path="/:str/p/:id"
          component={
            isFleekEnabled && currentStore === FLEEK_STORE_NAME ? ProductPageFleek : ProductPage
          }
        />
        <Route
          exact
          path="/p/:id"
          component={
            isFleekEnabled && currentStore === FLEEK_STORE_NAME ? ProductPageFleek : ProductPage
          }
        />
      </Switch>
    </Suspense>
  </Router>
);
const mapStateToProps = state => {
  console.log(getMasterFlagFleek(state));
  return {
    currentStore: getCurrentStore(state),
    isFleekEnabled: getMasterFlagFleek(state) === 'ON'
  };
};
export default connect(mapStateToProps)(routes);
